/**
 * 세션 스토리지 캐시 관리 유틸리티
 * 검색 결과 캐시 무효화 및 관리를 담당
 */

type SearchCacheType = "sentences" | "tags" | "all"

/**
 * 세션 스토리지에서 검색 관련 캐시 키들을 찾아 반환
 */
const getSearchCacheKeys = (type?: SearchCacheType): string[] => {
  if (typeof window === "undefined") return []

  const keys: string[] = []
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i)
    if (!key) continue

    const isSearchKey =
      key.startsWith("search-sentences-") || key.startsWith("search-tags-")

    if (!isSearchKey) continue

    if (type === "sentences" && key.startsWith("search-sentences-")) {
      keys.push(key)
    } else if (type === "tags" && key.startsWith("search-tags-")) {
      keys.push(key)
    } else if (type === "all" || !type) {
      keys.push(key)
    }
  }

  return keys
}

/**
 * 특정 키워드의 검색 캐시를 삭제
 * @param keyword 검색 키워드
 * @param type 캐시 타입 (기본값: "all")
 */
export const clearSearchCacheByKeyword = (
  keyword: string,
  type: SearchCacheType = "all",
): void => {
  if (typeof window === "undefined") return

  const keysToRemove: string[] = []

  if (type === "sentences" || type === "all") {
    keysToRemove.push(`search-sentences-${keyword}`)
  }

  if (type === "tags" || type === "all") {
    keysToRemove.push(`search-tags-${keyword}`)
  }

  keysToRemove.forEach((key) => {
    sessionStorage.removeItem(key)
  })

  console.log(`검색 캐시 삭제 완료 - 키워드: ${keyword}, 타입: ${type}`)
}

/**
 * 모든 검색 관련 캐시를 삭제
 */
export const clearAllSearchCache = (): void => {
  if (typeof window === "undefined") return

  const searchKeys = getSearchCacheKeys("all")

  searchKeys.forEach((key) => {
    sessionStorage.removeItem(key)
  })

  console.log(
    `전체 검색 캐시 삭제 완료. 삭제된 키 개수: ${searchKeys.length}개`,
    searchKeys,
  )
}

/**
 * 리다이렉트 URL 관리
 */
const REDIRECT_KEY = "pending-redirect-url"

/**
 * 리다이렉트 URL을 세션스토리지에 저장
 * @param url 리다이렉트할 URL
 */
export const saveRedirectUrl = (url: string): void => {
  if (typeof window === "undefined") return
  sessionStorage.setItem(REDIRECT_KEY, url)
  console.log(`리다이렉트 URL 저장: ${url}`)
}

/**
 * 저장된 리다이렉트 URL 조회
 * @returns 저장된 URL 또는 null
 */
export const getRedirectUrl = (): string | null => {
  if (typeof window === "undefined") return null
  return sessionStorage.getItem(REDIRECT_KEY)
}

/**
 * 리다이렉트 URL 삭제
 */
export const clearRedirectUrl = (): void => {
  if (typeof window === "undefined") return
  sessionStorage.removeItem(REDIRECT_KEY)
  console.log("리다이렉트 URL 제거 완료")
}
